import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { GROUP_MEETING_ROUTE_NAMES } from "./routeNames";

const routes: AppRouteRecordRaw[] = [
  {
    // Optional tab segment: see the student-meeting detail route.
    path: "/my-meetings/:tab(open|completed)?/group-meeting/:id",
    name: GROUP_MEETING_ROUTE_NAMES.MY_MEETING,
    component: () =>
      import(
        "meetings/group-meeting/pages/teacher/TeacherGroupMeetingPage.vue"
      ),
    meta: {
      title: "Mijn bespreking",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      hideSubmenu: true,
      hideTitle: true,
      exactRouteIdentifier: "myMeetings",
    },
  },
];

export default routes;
